
/* eslint-disable @typescript-eslint/no-shadow */
export namespace QuartileColor {
  export enum QuartileColor {
    QUARTILE_COLOR_1 = "QUARTILE_COLOR_1",
    QUARTILE_COLOR_2 = "QUARTILE_COLOR_2",
    QUARTILE_COLOR_3 = "QUARTILE_COLOR_3",
    QUARTILE_COLOR_4 = "QUARTILE_COLOR_4",
    QUARTILE_COLOR_5 = "QUARTILE_COLOR_5",
    DEFAULT_COLOR = "DEFAULT_COLOR",
  }

  export interface QuartileColorDTO {
    case: string;
  }

  export const fromDTO = (dto: QuartileColorDTO): QuartileColor => {
    if (dto === undefined || dto === null) {
      throw new InvalidQuartileColorError(
        `Invalid DTO ${dto} provided for QuartileColor.QuartileColor`
      );
    }
    switch (dto.case) {
      case "QUARTILE_COLOR_1":
        return QuartileColor.QUARTILE_COLOR_1;
      case "QUARTILE_COLOR_2":
        return QuartileColor.QUARTILE_COLOR_2;
      case "QUARTILE_COLOR_3":
        return QuartileColor.QUARTILE_COLOR_3;
      case "QUARTILE_COLOR_4":
        return QuartileColor.QUARTILE_COLOR_4;
      case "QUARTILE_COLOR_5":
        return QuartileColor.QUARTILE_COLOR_5;
      case "DEFAULT_COLOR":
        return QuartileColor.DEFAULT_COLOR;
      default:
        throw new InvalidQuartileColorError(
          `Case ${dto.case} is not valid case of QuartileColor.QuartileColor`
        );
    }
  };

  export const toDTO = (quartileColor: QuartileColor): QuartileColorDTO => {
    const enumDTO = {
      case: QuartileColor[quartileColor],
    };
    return enumDTO;
  };
}

export class InvalidQuartileColorError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorError";
  }
}
export class InvalidQuartileColorQuartileColor1Error extends InvalidQuartileColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorQuartileColor1Error";
  }
}

export class InvalidQuartileColorQuartileColor2Error extends InvalidQuartileColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorQuartileColor2Error";
  }
}

export class InvalidQuartileColorQuartileColor3Error extends InvalidQuartileColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorQuartileColor3Error";
  }
}

export class InvalidQuartileColorQuartileColor4Error extends InvalidQuartileColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorQuartileColor4Error";
  }
}

export class InvalidQuartileColorQuartileColor5Error extends InvalidQuartileColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorQuartileColor5Error";
  }
}

export class InvalidQuartileColorDefaultColorError extends InvalidQuartileColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorDefaultColorError";
  }
}
